module.exports = __webpack_public_path__ + "img/1440.1ec8d2df.jpg";